export default function PageLoader() {
  return (
    <div style={{ minHeight:'100vh', display:'flex', alignItems:'center', justifyContent:'center', background:'#f9fafb' }}>
      <div style={{ width:'36px', height:'36px', borderRadius:'50%', border:'3px solid #e5e7eb', borderTopColor:'#1a56db', animation:'lpms-spin 0.7s linear infinite' }} />
      <style>{`@keyframes lpms-spin { to { transform: rotate(360deg); } }`}</style>
    </div>
  );
}
